<div class="orders py-4">
  <div class="row">
    <div class="col-2 mb-4">
      <div class="form-group has-float-label">
        <p-select
          [(ngModel)]="selectedBc"
          class="p-0"
          (onChange)="getMultiLedgerAssociations()"
          [options]="bcList"
          [filter]="true"
          [showClear]="true">
          <ng-template let-item #item>
            {{ item.firstName }} {{ item.lastName }} {{ item.personnelNumber }}
          </ng-template>
        </p-select>
        <label class="form-label">Branding Consultant</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-2 mb-4">
      <div class="form-group has-float-label">
        <p-select
          [(ngModel)]="selectedAssociatedBc"
          class="p-0"
          [options]="availableAssociatedBcList"
          [filter]="true"
          [showClear]="true">
          <ng-template let-item #item>
            {{ item.firstName }} {{ item.lastName }} {{ item.personnelNumber }}
          </ng-template>
        </p-select>
        <label class="form-label">Multi Ledger Linked BC</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-2 mb-4">
      <button
        class="btn btn-primary"
        type="submit"
        (click)="addMultiLedgerAssociation()">
        Add
      </button>
    </div>
  </div>
  <div class="row">
    <div class="billers-list">
      <header
        class="samplepo-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
        <h1 class="m-0">
          <ng-container>Associations</ng-container>
        </h1>

        <div class="samplepo-panel ml-auto d-flex justify-content-between">
          <div
            class="ms-3 nav-link p-0 d-flex align-items-center"
            *ngIf="selectedAssociations && selectedAssociations.length">
            <i class="icon-Delete me-2"></i>
            <a class="link" (click)="deleteMultiLedgerAssociation()">Delete</a>
          </div>
        </div>
      </header>
      <p-table
        #dt
        responsiveLayout="scroll"
        [value]="associations"
        [(selection)]="selectedAssociations"
        styleClass="p-datatable-customers no-overfollow ordersLineItems no-wrap table-hover-bg"
        [rowHover]="true"
        [rows]="20"
        [showCurrentPageReport]="true"
        [paginator]="false"
        [filterDelay]="0"
        selectionMode="multiple">
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th class="number">Personal #</th>
            <th class="status">Name</th>
            <th class="name">Phone</th>
            <th class="name">Email</th>
          </tr>
          <tr *ngIf="associations && associations.length">
            <th></th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="associatedBCPersonnelNumber"
                  id="associatedBCPersonnelNumber"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'associatedBCPersonnelNumber',
                      'contains'
                    )
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="name"
                  id="name"
                  (input)="
                    dt.filter($any($event.target).value, 'name', 'contains')
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="phone"
                  id="phone"
                  (input)="
                    dt.filter($any($event.target).value, 'phone', 'contains')
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="email"
                  id="email"
                  (input)="
                    dt.filter($any($event.target).value, 'email', 'contains')
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-associations let-rowIndex="rowIndex">
          <tr
            class="p-selectable-row"
            [pSelectableRow]="associations"
            [pSelectableRowIndex]="rowIndex">
            <td class="col-center">
              <p-tableCheckbox
                class=""
                [value]="associations"
                [pSelectableRow]="associations"></p-tableCheckbox>
            </td>
            <td>{{ associations.associatedBCPersonnelNumber }}</td>
            <td>{{ associations.name }}</td>
            <td>{{ associations.phone }}</td>
            <td>{{ associations.email }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="30">No Associations Found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
